export function scrollToTop() {
    let $button = $(".top-link");

    $button.on("click", function (e) {
        e.preventDefault();
        $("body, html").animate({
            scrollTop: 0
        }, "300" );
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollToTop.js